/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuFilterAvailability_itemSearch = {
    readonly displayUriRef: string | null;
    readonly appliedFilters: ReadonlyArray<{
        readonly name: string | null;
        readonly values: ReadonlyArray<{
            readonly linkReference: string | null;
            readonly urlLabel: string | null;
            readonly count: number | null;
        } | null> | null;
    } | null> | null;
    readonly " $refType": "SbSharedRefineMenuFilterAvailability_itemSearch";
};
export type SbSharedRefineMenuFilterAvailability_itemSearch$data = SbSharedRefineMenuFilterAvailability_itemSearch;
export type SbSharedRefineMenuFilterAvailability_itemSearch$key = {
    readonly " $data"?: SbSharedRefineMenuFilterAvailability_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuFilterAvailability_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuFilterAvailability_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "displayUriRef",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "appliedFilters",
      "storageKey": null,
      "args": null,
      "concreteType": "SearchBrowseParsedParam",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "values",
          "storageKey": null,
          "args": null,
          "concreteType": "SearchBrowseParsedParamValue",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "linkReference",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "urlLabel",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "count",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '37e494919d49505e01d837d68a014a6e';
export default node;
